import { LowerCasePipe, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AssetDto, GalleryAccessLevel, GalleryDto } from '@picflow/types';
import { downloadSizes } from 'src/app/consts';
import { convertGalleryDownloadSize } from 'src/app/lib/convert-gallery-download-size';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-download-size-selection',
  templateUrl: './download-size-selection.component.html',
  styleUrls: ['./download-size-selection.component.scss'],
  standalone: true,
  imports: [NgIf, ButtonMenuItemComponent, SvgComponent, NgFor, LowerCasePipe, TranslatePipe],
})
export class DownloadSizeSelectionComponent implements OnChanges {
  @Input() accessLevel: GalleryAccessLevel;
  @Input() asset: AssetDto;
  @Input() gallery: GalleryDto;
  @Input() previewWidth?: number;
  @Input() activeWidth?: number;
  @Output() onSelect = new EventEmitter();
  sizes = downloadSizes;
  allowOriginalDownload: boolean;

  ngOnChanges() {
    const enabledSizes = convertGalleryDownloadSize(this.gallery.download_media_size);
    if (this.accessLevel !== 'edit') {
      this.sizes = this.sizes.filter(s => enabledSizes[s.name] && s.name !== 'original' && s.name !== 'reserved');
      this.allowOriginalDownload = enabledSizes.original;
    } else {
      this.allowOriginalDownload = true;
    }

    if (this.asset.type === 'video') {
      this.sizes = [];
    } else {
      const filteredSizes = this.asset.version_data.data
        ? this.sizes.filter(s => this.asset.version_data.data.width >= s.size)
        : [];
      if (!filteredSizes.length && !this.allowOriginalDownload) {
        // no sizes are big enough, and the original is not allowed to be download, so in this case we allow the download of the smallest allowed size
        const smallest = this.sizes[0];
        if (smallest) filteredSizes.push(smallest);
      }
      this.sizes = filteredSizes;
    }
  }

  getHeight(width: number) {
    const aspect = this.asset.version_data.data.height / this.asset.version_data.data.width;
    return Math.round(width * aspect);
  }
}
